// extracted by mini-css-extract-plugin
export var checkIcon = "_d-2";
export var heading = "_d-1";
export var panel = "_d-0";